import { render } from "./ModalAddUpdateCase.vue?vue&type=template&id=7c3222fa&scoped=true"
import script from "./ModalAddUpdateCase.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateCase.vue?vue&type=script&lang=js"

import "./ModalAddUpdateCase.vue?vue&type=style&index=0&id=7c3222fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3222fa"]])

export default __exports__